import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { NOTIFICATION_TYPES } from './constants';
import NotificationsContext from '../NotificationsContext';

import './notificator.css';

const Notificator = (props) => {
  const {
    type,
    message,
    id
  } = props;

  const notification = _.isEmpty(type) || _.isEmpty(message)
    ? null
    : (
      <NotificationsContext.Consumer id={id}>
        {(notyf) => {
          try {
            if (notyf && typeof notyf[type] === 'function') {
              // Call as a method to preserve `this` binding inside Notyf
              notyf[type](message);
            }
            else {
              // silently ignore if notyf not available
            }
          }
          catch (e) {
            // ignore notification errors in production
          }
          return null;
        }}
      </NotificationsContext.Consumer>
    );

  return notification;
};

Notificator.propTypes = {
  type: PropTypes.oneOf([
    NOTIFICATION_TYPES.EMPTY,
    NOTIFICATION_TYPES.SUCCESS,
    NOTIFICATION_TYPES.ERROR
  ]).isRequired,
  message: PropTypes.string.isRequired,
  id: PropTypes.number
};

const mapStateToProps = (state) => {
  const {
    type,
    message,
    id
  } = state.notificator;

  return {
    type,
    message,
    id
  };
};

export default connect(mapStateToProps)(Notificator);
